import React, { useContext, useState, ReactNode } from 'react';
import { Route } from 'react-router-dom';

import SubNavigation from 'components/SubNavigation/SubNavigation';
import PerformanceSummary from './PerformanceSummary';
import Physical from './Physical';
import Browse from './View';
import Concerts from '../Shared/Concerts';

import { overviewSubTopics } from 'topics';
import { IEntityPageComponentProps } from 'pages/Entity/shared';
import { EntityContext, SalesTypes } from 'context/entityContext';
import TopicFilters from 'components/TopicFilters/TopicFilters';
import Certifications from 'pages/Entity/Track/Shared/Certifications';

const Overview: React.FC<IEntityPageComponentProps> = (props) => {
  const { artistMetadata, match, pathPrefix } = props;
  const { entityId } = match.params;

  const { compareMode, topic } = useContext(EntityContext);

  const [selectedSalesType, setSelectedSalesType] = useState<SalesTypes>();

  return (
    <>
      <SubNavigation topic="overview" variants={overviewSubTopics} />
      <TopicFilters
        topic={topic[1] || topic[0]}
        compareMode={compareMode}
        selectedSalesType={selectedSalesType}
      />

      <Route
        exact
        path={`${pathPrefix}/track/${entityId}/overview/summary`}
        render={(): ReactNode => <PerformanceSummary />}
      />
      <Route
        exact
        path={`${pathPrefix}/track/${entityId}/overview/view`}
        render={(): any => (
          <Browse setSelectedSalesType={setSelectedSalesType} />
        )}
      />
      <Route
        exact
        path={`${pathPrefix}/track/${entityId}/overview/certifications`}
        render={(): ReactNode => <Certifications />}
      />
      <Route
        exact
        path={`${pathPrefix}/track/${entityId}/overview/concerts`}
        render={(): any => (
          <Concerts
            topic={topic.join('/')}
            artist={{
              entityType: artistMetadata?.type,
              entityId: artistMetadata?.id,
              name: artistMetadata?.displayName,
            }}
            compareMode={compareMode}
          />
        )}
      />
      <Route
        exact
        path={`${pathPrefix}/track/${entityId}/overview/physical`}
        render={(): ReactNode => <Physical />}
      />
    </>
  );
};

export default Overview;
